import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/auth';

const TeacherClasses = () => {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      const classesRes = await api.get('/teacher/classes', { headers });
      setClasses(Array.isArray(classesRes.data) ? classesRes.data : []);

      const subjectsRes = await api.get('/teacher/subjects', { headers });
      setSubjects(Array.isArray(subjectsRes.data) ? subjectsRes.data : []);
    } catch (err) {
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-6">Chargement...</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#2C3E50]">📚 Mes classes</h1>
        <p className="text-gray-500">Vos classes et matières</p>
      </div>

      {/* Matières enseignées */}
      {subjects.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="font-semibold text-[#2C3E50] mb-4">📖 Matières que j'enseigne</h3>
          <div className="flex flex-wrap gap-2">
            {subjects.map((subject) => (
              <span
                key={subject.id}
                className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium"
              >
                {subject.name} (coef. {subject.coefficient})
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Liste des classes */}
      {classes.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
          <p className="text-lg mb-2">📭 Aucune classe assignée</p>
          <p className="text-sm">Contactez l'administration pour être assigné à une classe.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {classes.map((cls) => (
            <div
              key={cls.id}
              className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition border-t-4 border-[#E67E22]"
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="text-xl font-bold text-[#2C3E50]">{cls.name}</h3>
                  <p className="text-sm text-gray-500">Niveau : {cls.level || 'N/A'}</p>
                </div>
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center">
                  <span className="text-[#E67E22] text-lg">📚</span>
                </div>
              </div>

              <div className="space-y-2 text-sm mb-4">
                <p>
                  👨‍🎓 <strong>{cls.students_count}</strong> élève(s)
                </p>
                {cls.section && <p>📌 Section : {cls.section}</p>}
              </div>

              {/* Actions rapides */}
              <div className="grid grid-cols-2 gap-2">
                <Link
                  to="/teacher/students"
                  className="text-center text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 py-2 rounded-lg transition"
                >
                  👨‍🎓 Élèves
                </Link>
                <Link
                  to="/teacher/attendance"
                  className="text-center text-xs bg-green-50 hover:bg-green-100 text-green-700 py-2 rounded-lg transition"
                >
                  📋 Appel
                </Link>
                <Link
                  to="/teacher/grades"
                  className="text-center text-xs bg-purple-50 hover:bg-purple-100 text-purple-700 py-2 rounded-lg transition"
                >
                  ✏️ Notes
                </Link>
                <Link
                  to="/teacher/results"
                  className="text-center text-xs bg-orange-50 hover:bg-orange-100 text-orange-700 py-2 rounded-lg transition"
                >
                  📊 Résultats
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Résumé */}
      {classes.length > 0 && (
        <div className="grid grid-cols-3 gap-4">
          <div className="bg-white rounded-xl shadow-md p-4 text-center border-l-4 border-blue-500">
            <p className="text-sm text-gray-500">Total classes</p>
            <p className="text-2xl font-bold text-blue-600">{classes.length}</p>
          </div>
          <div className="bg-white rounded-xl shadow-md p-4 text-center border-l-4 border-green-500">
            <p className="text-sm text-gray-500">Total élèves</p>
            <p className="text-2xl font-bold text-green-600">
              {classes.reduce((sum, c) => sum + (c.students_count || 0), 0)}
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-md p-4 text-center border-l-4 border-purple-500">
            <p className="text-sm text-gray-500">Matières</p>
            <p className="text-2xl font-bold text-purple-600">{subjects.length}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherClasses;